import { Typography, styled } from "@mui/material";

import {
  PhlebotomyCardActionsRow,
  PhlebotomyPrimaryActionButton,
} from "../components/BaseCard.styles";

import { themePalette } from "../../../theme";

export const LocationDistance = styled(Typography)`
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
  color: ${({ theme }) => theme.palette.primary.main};
  flex-shrink: 0;
  white-space: nowrap;
`;

export const FinderPrimaryActionButton = styled(PhlebotomyPrimaryActionButton)`
  width: var(--finder-primary-width);
  min-height: 45px;
  height: auto;
  padding-top: 10px;
  padding-bottom: 10px;
  overflow-wrap: anywhere;
`;

export const FinderCardActionsRow = styled(PhlebotomyCardActionsRow, {
  shouldForwardProp: (prop) =>
    prop !== "hasPrimaryAction" && prop !== "isSpanish",
})<{ hasPrimaryAction: boolean; isSpanish: boolean }>`
  --finder-primary-width: ${({ hasPrimaryAction, isSpanish }) =>
    hasPrimaryAction ? `${isSpanish ? 160 : 130}px` : "45px"};

  /* Reserve the same three gaps even when fewer than four actions are present. */
  gap: max(8px, calc((100% - 135px - var(--finder-primary-width)) / 3));

  & > * {
    flex-shrink: 0;
  }
`;
